/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Full Screen Icon component.
 */
export const MaterialFullScreenIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19545)'>
        <path d='M5 15.5H2V23H9.5V20H5V15.5ZM2 9.5H5V5H9.5V2H2V9.5ZM20 20H15.5V23H23V15.5H20V20ZM15.5 2V5H20V9.5H23V2H15.5Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_14304_19545'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MaterialFullScreenIcon;
